import React from 'react';

import {Button, CreateIcon, DeleteIcon, Input} from '@kit';

import css from './sheet.module.css';

type Props = {
	values: string[];
	onChange(values: string[]): void;
	placeholder?: string;
	addLabel?: string;
};

export const StringListEditor: React.FC<Props> = ({values, onChange, placeholder, addLabel = 'Добавить'}) => {
	const setValue = (index: number, value: string) =>
		onChange(values.map((current, currentIndex) => (currentIndex === index ? value : current)));

	return (
		<div className={css.stringList}>
			{values.map((value, index) => (
				<div key={index} className={css.stringListRow}>
					<Input
						value={value}
						placeholder={placeholder}
						onChange={(next) => setValue(index, String(next ?? ''))}
					/>
					<Button
						appearance="subtle"
						icon={<DeleteIcon />}
						aria-label="Удалить"
						onClick={() => onChange(values.filter((_, currentIndex) => currentIndex !== index))}
					/>
				</div>
			))}
			<div>
				<Button size="small" icon={<CreateIcon />} onClick={() => onChange([...values, ''])}>
					{addLabel}
				</Button>
			</div>
		</div>
	);
};
